import { createSlice } from "@reduxjs/toolkit";

export const candidateTabSlice = createSlice({
    name:'candidateTab',
    initialState:{
        value:'',
    },
    reducers:{
        updateCandidateTab:(state, action)=>{
             state.value = action.payload;
           
        }
    }
})

export const selectCandidateTab = (state)=>state.candidateTab.value

export const { updateCandidateTab } = candidateTabSlice.actions

export default candidateTabSlice.reducer